export enum ERROR_CODES {
  ADD_JOURNEY_BLOCKER = 'add_journey_blocker',
  UNKNOWN = 'unknown',
}
